

































  import {Component, Vue} from 'vue-property-decorator'

  import Header from './Header.vue'
  import SideNav from './SideNav.vue'
  import Footer from './Footer.vue'
  import NavBar from '@/components/layout/standard/NavBar.vue'
  import SideNavExtraLinks from '@/components/layout/standard/SideNavExtraLinks.vue'

  @Component({
  components: {
    SideNavExtraLinks,
    NavBar,
    Footer,
    SideNav,
    Header,
  },
})
export default class StandardLayout extends Vue {
  private displaySideNav = true
}
